// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__imJ6R"};